"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _Toggleable = _interopRequireDefault(require("../../darkmatter/Toggleable"));

var _MobileLink = _interopRequireDefault(require("./MobileLink"));

var _default = function _default(_ref) {
  var logo = _ref.logo,
      links = _ref.links,
      linksAs = _ref.linksAs,
      className = _ref.className,
      centerMobileNavItems = _ref.centerMobileNavItems,
      linkComponent = _ref.linkComponent;
  return _react["default"].createElement(_semanticUiReact.Segment, {
    className: className
  }, _react["default"].createElement(_Toggleable["default"], null, function (toggle, onToggle) {
    return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("div", {
      style: {
        textAlign: 'center',
        position: 'relative',
        minHeight: 'calc(50px - 2em)'
      }
    }, _react["default"].createElement(_semanticUiReact.Button, {
      onClick: onToggle,
      icon: "bars",
      size: "massive",
      style: {
        position: 'absolute',
        left: 5,
        top: 'calc(50% - 12px)',
        padding: 0,
        background: 'none'
      }
    }), logo), toggle && _react["default"].createElement("div", null, links.map(function (_ref2) {
      var slug = _ref2.slug,
          pageTitle = _ref2.pageTitle,
          internal = _ref2.internal;
      return _react["default"].createElement(_MobileLink["default"], {
        linkComponent: linkComponent,
        centerMobileNavItems: centerMobileNavItems,
        linksAs: linksAs,
        slug: slug,
        pageTitle: pageTitle,
        onToggle: onToggle,
        internal: internal
      });
    })));
  }));
};

exports["default"] = _default;